import React from 'react'
import withPage, { setCacheMaxAge } from 'server/withPage'
import { Query } from 'react-apollo'
import { bindActionCreators } from 'redux'
import { PAGE_QUERY, VIEWER_QUERY } from './graphql'
import HomePage from 'components/pages/HomePage'

class Container extends React.Component {
  static async getInitialProps({ req, res, config, isLogin }) {
    if (!isLogin) {
      setCacheMaxAge(res, 'page-home', 180)
    }
  }

  constructor(props) {
    super(props)
    this.state = {
      currentUser: null,
      favorites: [],
    }
  }

  async componentDidMount() {
    // renderでQueryの入れ子もできるが、syncでリクエストが送られるため、
    // 表示速度を考えここで。apollo-link-batch-httpを使うこともできるが
    // 影響を限定するためひとまずこのように実装
    const { data, error, loading } = await this.client.query({
      query: VIEWER_QUERY,
    })
    const favorites = data.viewer
      ? data.viewer.favorites.results.map(favorite => favorite.favorable)
      : []
    this.setState({
      currentUser: data.viewer,
      favorites: favorites,
    })
  }

  eventTypeOtherDidSelect = e => {
    const category = e.currentTarget.value
    window.location.href = `/search?event_type=${category}&with_recommend=${true}`
  }

  render() {
    return (
      <Query query={PAGE_QUERY}>
        {({ loading, error, data, client }) => {
          if (loading) return 'Loading...'
          if (error) return `Error! ${error.message}`

          this.client = client
          const mainEventTypes = []
          const subEventTypes = []
          const otherEventTypes = []
          const categoryRooms = {}
          const totalCount =
            parseInt(data.countRooms.pageInfo.totalCount) +
            parseInt(data.stayRooms.pageInfo.totalCount)
          const eventTypes = data.eventTypes.results.concat(
            data.stayEventTypes.results,
          )

          {
            eventTypes.forEach((eventType, index) => {
              if (['party', 'class', 'stay'].indexOf(eventType.name) != -1) {
                mainEventTypes.push(eventType)
              } else if (
                ['photo_shoot', 'film_shoot', 'sports', 'other'].indexOf(
                  eventType.name,
                ) != -1
              ) {
                subEventTypes.push(eventType)
              } else if (
                [
                  'performance',
                  'studio',
                  'office',
                  'wedding',
                  'event',
                  'other',
                ].indexOf(eventType.name) != -1
              ) {
                otherEventTypes.push(eventType)
              }
              categoryRooms[eventType.name] =
                data[`${eventType.name.split('_')[0]}Rooms`].results
            })
          }

          return (
            <HomePage
              title={i18n.t('server.home.title')}
              description={i18n.t('server.home.description')}
              linkCanonical="https://www.spacemarket.com"
              config={this.props.config}
              currentUser={this.state.currentUser}
              mainEventTypes={mainEventTypes}
              subEventTypes={subEventTypes}
              otherEventTypes={otherEventTypes}
              categoryRooms={categoryRooms}
              staffFeatures={data.feature.items.results}
              eventTypes={data.eventTypes.results}
              topics={data.topics.results}
              favorites={this.state.favorites}
              eventTypeOtherDidSelect={this.eventTypeOtherDidSelect}
              totalCount={totalCount}
              data={data}
              location={this.props.location}
            />
          )
        }}
      </Query>
    )
  }
}

function mapStateToProps(state) {
  return state
}
function mapDispatchToProps(dispatch: Dispatch<*>) {
  const bindActions = {}
  return { actions: bindActionCreators(bindActions, dispatch) }
}
export default withPage(Container, mapStateToProps, mapDispatchToProps)



// WEBPACK FOOTER //
// ./src/containers/pages/HomePage/index.js